import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { createRenewalOrder, getRenewalOrderDetail } from "../service/service";
import Header from "../../../common/header/Header";
import PaymentStatusCard from "./PaymentStatusCard.jsx";
import { Modal, Button } from "react-bootstrap";

const RenewalOrderPage = () => {
  let { enc_data } = useParams();
  const [paymentData, setPaymentData] = useState();
  const [attemptData, setAttemptData] = useState();
  const [isPayButtonDisabled, setIsPayButtonDisabled] = useState(false);
  const [consent1, setConsent1] = useState(true);
  const [consent2, setConsent2] = useState(true);
  const [showTermsModal, setShowTermsModal] = useState(false);

  useEffect(() => {
    getRenewalOrderDetail(enc_data, setPaymentData, setAttemptData);
  }, []);

  const handlePayNow = () => {
    if (!consent1 || !consent2) {
      alert("Please accept both consent statements to proceed");
      return;
    }
    setIsPayButtonDisabled(true);
    createRenewalOrder(enc_data);
  };

  return (
    <div>
      {paymentData && (
        <div className="campaign_payment">
          <div className="page_wrapper">
            <div className="header-wrapper">
              <Header />
              <div className="header_bottom">
                <div className="header-bottom-contain">
                  <div className="header_bottom_text">
                    Aditya Birla Sun Life Insurance Company Limited
                  </div>
                </div>
              </div>
            </div>
            <div className="payment-container">
              <div className="name-wrapper ">
                <h3>Welcome,</h3>
                <h5>{paymentData && paymentData.data.customer_name}</h5>
              </div>
              <div className="details-wrapper">
                <div className="details-header">
                  <h4>Renewal Order Summary</h4>
                  <h3>Policy: {paymentData.data.policy_number}</h3>
                </div>
                <div className="details-content">
                  <div className="row">
                    {paymentData && (
                      <div className="row">
                        <div className="col-md-3 col-12">
                          <div className="payment_entity">
                            <span>Policy Owner Name</span>
                            <h6>{paymentData.data.customer_name}</h6>
                          </div>
                        </div>
                        <div className="col-md-3 col-12">
                          <div className="payment_entity">
                            <span>Email Id</span>
                            <h6>{paymentData.data.customer_email}</h6>
                          </div>
                        </div>
                        <div className="col-md-3 col-12">
                          <div className="payment_entity">
                            <span>Mobile No.</span>
                            <h6>{paymentData.data.customer_phone}</h6>
                          </div>
                        </div>
                        <div className="col-md-3 col-12">
                          <div className="payment_entity">
                            <span>Amount</span>
                            <h6>{paymentData.data.amount}</h6>
                          </div>
                        </div>
                        <div className="col-md-3 col-12">
                          <div className="payment_entity">
                            <span>Policy No.</span>
                            <h6>{paymentData.data.policy_number}</h6>
                          </div>
                        </div>
                      </div>
                    )}
                    {paymentData.success &&
                      (paymentData?.plOrderData?.length <= 1 ||
                        typeof paymentData?.plOrderData === "undefined") && (
                        <div className="col-12">
                          <div
                            className="consent-section"
                            style={{ marginTop: "20px" }}
                          >
                            <div
                              className="alert alert-info"
                              style={{
                                fontSize: "12px",
                                backgroundColor: "#e7f3ff",
                                border: "1px solid #b3d9ff",
                                borderRadius: "6px",
                                margin: "0",
                                marginTop: "15px",
                                marginBottom: "15px",
                                padding: "12px",
                              }}
                            >
                              <strong>Note:</strong> Convenience Fee at 0.95%
                              will be charged for renewal premiums made through
                              Non-Amex credit cards. For Amex Credit Cards and
                              wallet payments, Convenience fee will be charged
                              at 1.20%.
                            </div>
                            {/* Consent Checkboxes */}
                            <div
                              className="form-check"
                              style={{
                                padding: "0",
                                paddingLeft: "30px",
                                margin: "0 0 12px 0",
                              }}
                            >
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="consent1"
                                checked={consent1}
                                onChange={(e) => setConsent1(e.target.checked)}
                                style={{ marginTop: "0.3rem" }}
                              />
                              <p
                                className="form-check-label ms-2"
                                htmlFor="consent1"
                                style={{ fontSize: "13px", lineHeight: "1.5" }}
                              >
                                I agree to share my details with other companies
                                of the same parent company for receiving latest
                                offers and product recommendations.
                              </p>
                            </div>

                            <div
                              className="form-check"
                              style={{
                                padding: "0",
                                paddingLeft: "30px",
                                margin: "0 0 20px 0",
                              }}
                            >
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="consent2"
                                checked={consent2}
                                onChange={(e) => setConsent2(e.target.checked)}
                                style={{ marginTop: "0.3rem" }}
                              />
                              <p
                                className="form-check-label ms-2"
                                htmlFor="consent2"
                                style={{ fontSize: "13px", lineHeight: "1.5" }}
                              >
                                I hereby confirm that I am the policy owner and
                                declare that the premium of this policy is being
                                paid from a bank account/credit card which
                                belongs to me as per requirement of IRDAI
                                (Manner of Premium Payment) Regulations. I agree
                                to the{" "}
                                <button
                                  style={{
                                    color: "#dc3545",
                                    cursor: "pointer",
                                    backgroundColor: "transparent",
                                    border: "none",
                                    textDecoration: "underline",
                                    fontWeight: "500",
                                  }}
                                  onClick={() => setShowTermsModal(true)}
                                >
                                  Terms and conditions
                                </button>
                              </p>
                            </div>
                          </div>
                          <button
                            className="pay-btn"
                            disabled={
                              isPayButtonDisabled || !consent1 || !consent2
                            }
                            onClick={handlePayNow}
                            style={{
                              opacity: consent1 && consent2 && !isPayButtonDisabled ? 1 : 0.5,
                              cursor:
                                consent1 && consent2 && !isPayButtonDisabled
                                  ? "pointer"
                                  : "not-allowed",
                            }}
                          >
                            {isPayButtonDisabled ? "Processing..." : "Proceed to Pay"}
                          </button>
                        </div>
                      )}
                  </div>
                </div>
              </div>
            </div>
            {paymentData?.plOrderData && (
              <PaymentStatusCard
                orderStatus={paymentData?.plOrderData?.status}
                pa_txn_id={paymentData?.plOrderData?.current_attempt_id}
                txn_amount={paymentData?.plOrderData?.amount}
                paymentData={paymentData}
                attempData={attemptData}
              />
            )}
          </div>
        </div>
      )}

      {/* Terms and Conditions Modal */}
      <Modal
        show={showTermsModal}
        onHide={() => setShowTermsModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Terms and Conditions</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p style={{ fontSize: "14px", color: "#666", lineHeight: "1.6" }}>
            Incase you do not receive a payment confirmation message, kindly
            verify your bank account/credit card details. If your account is
            debited, then your transaction is executed successfully and you need
            not reinitiate the same. Due to a technical / response issue, the
            confirmation may not have been received by you. Your payment will be
            reflected in your policy within 4 working days from the date of
            payment or on the due date, whichever is later. We request you to
            kindly check the status of the same and revert in case of any
            discrepancy.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={() => {
              setShowTermsModal(false);
              setConsent2(true);
            }}
            style={{
              backgroundColor: "#8B4513",
              borderColor: "#8B4513",
              fontWeight: "500",
            }}
          >
            Accept
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default RenewalOrderPage;
